(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/marketplace/components/welcome/assets/javascripts/welcome-screen.js') >= 0) return;  svs.modules.push('/modules/marketplace/components/welcome/assets/javascripts/welcome-screen.js');

'use strict';

const {
  useEffect
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  Route,
  useHistory
} = ReactRouterDOM;
const {
  Loader
} = svs.components.ReactLoader;
const {
  DocumentTitle
} = svs.components.lbUtils;
const {
  WelcomeTeamList,
  RetailList,
  TogetherList
} = svs.marketplace.components.welcome;
const {
  JoinTeam
} = svs.components.marketplace.joinTeam;
const {
  ErrorScreen
} = svs.components.marketplace.errorScreen;
const {
  selectors,
  teams
} = svs.components.marketplaceData;
const {
  teamType
} = svs.components.marketplaceData.teams.services.teamTypes;
const {
  chatData
} = svs.components.chat;
const createPath = '/skapa-lag?returnUrl=/';
const findPath = 'hitta-andelsspel';
const joinPath = '/bli-medlem/:invitationToken?';
const WelcomeScreenType = Object.freeze({
  RETAIL: 'retail',
  TOGETHER: 'together'
});
const WelcomeScreen = _ref => {
  let {
    type
  } = _ref;
  const loggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const history = useHistory();
  const dispatch = useDispatch();
  let groupTypeFilter;
  switch (type) {
    case WelcomeScreenType.TOGETHER:
      groupTypeFilter = teamType.PRIVATE;
      break;
    case WelcomeScreenType.RETAIL:
      groupTypeFilter = teamType.RETAILER;
      break;
    default:
      break;
  }
  const fetchAllTeams = () => dispatch(teams.actions.fetchAllTeamsAction(groupTypeFilter));
  const getUnread = () => dispatch(chatData.actions.getUnread());
  const error = useSelector(state => state.Teams.error);
  const hasTeams = useSelector(selectors.teams.getTeams).length > 0;
  const hasRetailers = useSelector(selectors.teams.getRetailers).filter(retailer => retailer.isFollowing).length > 0;
  const loading = useSelector(state => state.Teams.loading || !state.Teams.hasFetched && loggedIn);
  useEffect(() => {
    const body = document.querySelector('body');
    body.classList.remove('bg-white');
    body.classList.add('bg-sport-50');
    if (loggedIn) {
      getUnread();
      fetchAllTeams();
    }
    return () => {
      body.classList.remove('bg-sport-50');
      body.classList.add('bg-white');
    };
  }, []);
  if (loading && !hasTeams && !hasRetailers) {
    return React.createElement("div", {
      className: "marketplace-full-height marketplace-center-container",
      "data-testid": "qa-mkp-welcome-loading"
    }, React.createElement(Loader, {
      inverted: true
    }));
  }
  const documentTitle = React.createElement(DocumentTitle, {
    title: "Spela tillsammans"
  });
  const renderViewForType = () => {
    switch (type) {
      case WelcomeScreenType.RETAIL:
        return React.createElement(RetailList, {
          hasRetailers: hasRetailers
        });
      case WelcomeScreenType.TOGETHER:
        return React.createElement(TogetherList, {
          hasTeams: hasTeams
        });
      default:
        return React.createElement(WelcomeTeamList, {
          hasRetailers: hasRetailers,
          hasTeams: hasTeams,
          history: history,
          isAuthenticated: loggedIn,
          linkTo: createPath,
          linkToFind: findPath
        });
    }
  };
  if (error) {
    return React.createElement(React.Fragment, null, documentTitle, React.createElement(ErrorScreen, {
      buttonText: "F\xF6rs\xF6k igen",
      errorMessage: "Vi lyckades inte h\xE4mta information om dina lag."
    }));
  }
  return React.createElement(React.Fragment, null, documentTitle, renderViewForType(), React.createElement(Route, {
    component: JoinTeam,
    exact: true,
    path: joinPath
  }));
};
setGlobal('svs.marketplace.components.welcome.WelcomeScreen', WelcomeScreen);
setGlobal('svs.marketplace.components.welcome.WelcomeScreenType', WelcomeScreenType);

 })(window);